export default "__VITE_ASSET__f05ac17e__"